import type React from 'react'

type MarginsLayoutProps = {
  children: React.ReactNode
}

export function MarginsLayout({ children }: MarginsLayoutProps) {
  return <section className='mx-auto max-w-xl lg:max-w-7xl'>{children}</section>
}
